import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"

import img from "./chamferingProcess.png"

const 端子部の面取り加工 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { chamferingProcess: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="端子部の面取り加工" src={img}>
      <RadioGroup
        name={FIELD_NAMES.端子部の面取り加工}
        selectedValue={values.chamferingProcess}
        onChange={handlers.radio}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.端子部の面取り加工.しない.value}>しない</Radio>
          <Radio value={ESTIMATE_CONSTANT.端子部の面取り加工.角度指定無し.value}>角度指定無し</Radio>
          <Radio value={ESTIMATE_CONSTANT.端子部の面取り加工["角度：20度 深さ：1.8mm"].value}>
            角度：20度 深さ：1.8mm
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.端子部の面取り加工["角度：30度 深さ：1.0mm"].value}>
            角度：30度 深さ：1.0mm
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.端子部の面取り加工["角度：45度 深さ：0.5mm"].value}>
            角度：45度 深さ：0.5mm
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.chamferingProcess} />
    </OneClickField>
  )
}

export default 端子部の面取り加工
